export default (state, {
  instanceKey
}) => {
  let newFieldValue = {
    ...state
  };

  newFieldValue[`${instanceKey}_validating`] = true;

  return newFieldValue;
};
